import React from "react";
import { Card, ListGroup, Form, Button, Spinner, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faFileAlt, 
  faCalendarAlt, 
  faFilter,
  faEraser
} from "@fortawesome/free-solid-svg-icons";

const ReportListSidebar = ({
  reportsList,
  filteredReportsList,
  selectedReport,
  isLoading,
  dateFilter,
  onReportSelect,
  onDateFilterChange,
  onClearDateFilter
}) => {
  return (
    <Card className="shadow-sm report-card">
      <Card.Header className="bg-secondary text-white d-flex align-items-center">
        <FontAwesomeIcon
          icon={faFileAlt}
          className="me-2"
        />
        <h6 className="mb-0">Lista Raportów</h6>
      </Card.Header>
      
      {/* Date Filter Section */}
      <div className="p-3 border-bottom bg-light">
        <Form>
          <Row className="g-2">
            <Col md={5}>
              <Form.Group>
                <Form.Label className="small mb-1">Data od:</Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={dateFilter.startDate}
                  onChange={(e) => onDateFilterChange('startDate', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={5}>
              <Form.Group>
                <Form.Label className="small mb-1">Data do:</Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={dateFilter.endDate}
                  onChange={(e) => onDateFilterChange('endDate', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Label className="small mb-1">&nbsp;</Form.Label>
              <div className="d-grid">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={onClearDateFilter}
                  title="Wyczyść filtr dat"
                >
                  <FontAwesomeIcon icon={faEraser} />
                </Button>
              </div>
            </Col>
          </Row>
          {(dateFilter.startDate || dateFilter.endDate) && (
            <div className="mt-2">
              <small className="text-muted d-flex align-items-center">
                <FontAwesomeIcon icon={faFilter} className="me-1" />
                Filtrowanie aktywne: {filteredReportsList.length} z {reportsList.length} raportów
              </small>
            </div>
          )}
        </Form>
      </div>

      <Card.Body className="p-0">
        <div className="reports-list-container">
          {isLoading ? (
            <div className="text-center p-4">
              <Spinner
                animation="border"
                variant="secondary"
              />
              <p className="mt-2 mb-0">Ładowanie raportów...</p>
            </div>
          ) : reportsList.length === 0 ? (
            <div className="text-center p-4 text-muted">
              <FontAwesomeIcon
                icon={faFileAlt}
                size="2x"
                className="mb-2"
              />
              <p className="mb-0">Brak dostępnych raportów</p>
            </div>
          ) : filteredReportsList.length === 0 ? (
            <div className="text-center p-4 text-muted">
              <FontAwesomeIcon
                icon={faCalendarAlt}
                size="2x"
                className="mb-2"
              />
              <p className="mb-0">Brak raportów w wybranym przedziale dat</p>
              <Button 
                variant="outline-primary" 
                size="sm" 
                className="mt-2"
                onClick={onClearDateFilter}
              >
                <FontAwesomeIcon icon={faEraser} className="me-1" />
                Wyczyść filtr
              </Button>
            </div>
          ) : (
            <ListGroup variant="flush">
              {filteredReportsList.map((report, index) => (
                <ListGroup.Item
                  key={report._id || index}
                  action
                  onClick={() => onReportSelect(report._id)}
                  className={`report-list-item d-flex justify-content-between align-items-center py-3 ${
                    selectedReport?._id === report._id ? "active-report" : "inactive-report"
                  }`}
                  style={{
                    cursor: "pointer",
                    borderLeft: selectedReport?._id === report._id ? "4px solid #fff" : "4px solid transparent",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="text-muted me-2"
                      size="sm"
                    />
                    <p className="text-dark font-weight-bold me-2 mb-0">
                      {new Date(report.addedAt).toLocaleDateString("pl-PL", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                      })}
                      <small className="ms-2 text-muted">
                        {new Date(report.addedAt).toLocaleTimeString("pl-PL", {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })}
                      </small>
                    </p>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ReportListSidebar;